import React from "react";
import { Row, Col, Space, message, Button, Modal, Image, Drawer, Tooltip } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import { CloseOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import CompanyStore from "../store/CompanyStore";
import ServiceTemplateStore from "../store/ServiceTemplateStore";
import ServiceTemplateAdd from "./ServiceTemplateAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
class ServiceTemplate extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.companyStore = new CompanyStore(this);
    this.serviceTemplateStore = new ServiceTemplateStore(this);
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadData: 1,
      companyId: "",
      comp_value: "",
      listDataUpdate: false,
      openServiceTempForm: false,

      openDeleteModal: false,
      deleteData: {},
    };

    this.ExportMenuProps = {
      items: [
        {
          label: context.translate("_EXPORT_AS_EXCEL_"),
          key: "excel",
          icon: (
            <Image
              style={{ height: "16px", width: "16px" }}
              src={Excel}
            ></Image>
          ),
        },
      ],
      onClick: (val) => {
        if (this.serviceTemplateStore?.mainServiceList?.length == 0) return;
        const result = [];
        this.columns.map((obj) => result.push(obj.dataIndex));

        var getData = {
          companyId: this.state.companyId,
          colList: result,
        };

        if (val.key == "excel") {
          this.serviceTemplateStore.exportExcel(getData);
        }
      },
    };

    this.columns = [
      {
        title: context.translate("_SERVICE_ID_"),
        dataIndex: "serviceId",
        width: 10,
      },
      {
        title: context.translate("_NAME_"),
        dataIndex: "serviceName",
        width: 35,
        render: (val, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate('serviceTemplate') && this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },

      {
        title: context.translate("_ACTION_"),
        dataIndex: "action",
        width: 5,
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Space>
                {this.props.canUpdate('serviceTemplate') &&
                <Tooltip title={this.context.translate("_EDIT_")} placement="bottom">
                <Image
                  style={{
                    height: "19px",
                    width: "15px",
                    borderRadius: "0px",
                    cursor: "pointer",
                  }}
                  src={editIcon}
                  onClick={async (e) => {
                    e.preventDefault();
                    await this.onEdit(record);
                  }}
                ></Image>
                </Tooltip>}
                {this.props.canDelete('serviceTemplate') && 
                <Tooltip title={this.context.translate("_DELETE_")} placement="bottom">

                <Image
                  src={require("../assets/images/NewDesign/Delete.png")}
                  style={{ cursor: "pointer",width: "15px" }}
                  onClick={() =>
                    this.setState({
                      openDeleteModal: true,
                      deleteData: record,
                    })
                  }
                ></Image>
                </Tooltip>
                }
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Tooltip
                    placement="bottom"
                    // title="Delete Record"
                    title={this.context.translate("_DELETE_RECORD_")}
                    color={config.tooltipColorDelete}
                  >
                    <DeleteFilled style={{ color: config.deleteColor }} />
                  </Tooltip>
                </DeleteConfirm> */}
              </Space>
            </>
          );
        },
      },
    ];
  }
  async componentDidMount() {
    await this.handleSearch();
    this.setState({ pageSize: 50, loadData: 1 });
  }

  onEdit = async (record) => {
    await this.setState({ serviceId: record.serviceId });
    await this.setState({ openServiceTempForm: true });
  };

  async onDelete(record) {
    const response = await this.serviceTemplateStore.deleteRecord({
      serviceId: record.serviceId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.serviceTemplateStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
    });
    await this.setState({ loadData: 1, loading: false });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  closeModal = () => {
    this.setState({ openServiceTempForm: false });
  };

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openServiceTempForm: false });
      await this.handleSearch();
    }
  };

  refreshList = async () => {
    this.setState({ loading: true });
    await this.serviceTemplateStore.loadData({
      offset: 0,
      limit: 50,
    });
    this.setState({ loading: false, currentPage: 1 });
  };

  render() {
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_SERVICE_TEMPLATE_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  placement="left"
                  //  title="Add"
                  title={this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                  color={config.primaryColor}
                >
                  <Button
                    className="addButton"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={() =>
                      this.setState({
                        openServiceTempForm: true,
                        serviceId: "",
                      })
                    }
                  ></Button>
                </Tooltip>

                <Button
                 className="exportDropdown"
                  // style={{ backgroundColor: config.activeColor }}
                  onClick={() => this.serviceTemplateStore.exportExcel()}
                >
                   <DownloadOutlined />
                  {this.context.translate("_EXPORT_")}
                </Button>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              {/* <Input style={{ width: 200, borderRadius: "25px" }} /> */}
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space>
                <Tooltip title={this.context.translate("_REFRESH_")} placement="bottom">
                  <Image
                    style={{
                      height: 18,
                      alignItems: "center",
                      cursor: "pointer",
                      marginInlineEnd: "20px",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>

                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.serviceTemplateStore?.mainServiceList?.length > 0
                      ? false
                      : true
                  }
                  onClick={(val) => {
                    let result = [];
                    if (true) {
                      this.columns.map((obj) => result.push(obj.dataIndex));

                      var getData = {
                        companyId: this.state.companyId,
                        colList: result,
                      };
                      if (val) {
                        this.serviceTemplateStore.exportExcel(getData);
                      }
                    }
                  }}
                >
                  <Tooltip title={this.context.translate("_EXPORT_")} placement="bottom">

                    <Image
                      style={{
                        height: 18,
                        width: "auto",
                      }}
                      src={downloadIcon}
                    />
                  </Tooltip>
                </Button>

                {/* <Dropdown
                overlayClassName="export-dropdown"
                menu={this.ExportMenuProps}
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={kebabIcon}
                ></Image>
              </Dropdown> */}

                {this.props.canCreate('serviceTemplate') && <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({
                      openServiceTempForm: true,
                      serviceId: "",
                    })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                </Button>}
              </Space>
            </Col>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            total={this.serviceTemplateStore?.total}
            columns={this.columns}
            pageSize={this.state.pageSize}
            dataSource={this.serviceTemplateStore?.mainServiceList}
            loading={this.serviceTemplateStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openServiceTempForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal"
          //   title={this.context.translate("_SERVICE_TEMPLATE_")}
          //   centered
          //   open={this.state.openServiceTempForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openServiceTempForm: false, serviceId: "" });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openServiceTempForm}
            placement={this.context.locale.language === "english" ? "right" : "left"} 
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_SERVICE_TEMPLATE_")}
                <p className="formDescription">
                  {this.context.translate("_SERVICE_TEMPLATE_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openServiceTempForm: false })}
            onCancel={() =>
              this.setState({
                openServiceTempForm: false,
                serviceId: "",
              })
            }
          >
            <div style={{ height: "100%" }}>
              <ServiceTemplateAdd
                serviceId={this.state.serviceId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
ServiceTemplate.contextType = StoreContext;
export default observer(withRouter(ServiceTemplate));
